// Date 2021-06-21 16:52:38

import emOpcUaNodeInfoEouni from "@/store/em/opcClient/EmOpcUaNodeInfoEouniStore.js";
import emOpcUaNodeSubscriptionEouns from "@/store/em/opcClient/EmOpcUaNodeSubscriptionEounsStore.js";
import emOpcUaPublishRecordEoupr from "@/store/em/opcClient/EmOpcUaPublishRecordEouprStore.js";
import emOpcComputedEoc from "@/store/em/opcClient/EmOpcComputedEocStore.js";
import emOpcComputedTypeEoct from "@/store/em/opcClient/EmOpcComputedTypeEoctStore.js";
import emOpcWatchEow from "@/store/em/opcClient/EmOpcWatchEowStore.js";
import emOpcWatchConditionEowc from "@/store/em/opcClient/EmOpcWatchConditionEowcStore.js";
import emOpcComputedActionEoca from "@/store/em/opcClient/EmOpcComputedActionEocaStore.js";
import emOpcComputedEventEoce from "@/store/em/opcClient/EmOpcComputedEventEoceStore.js";

const genericEntities = [
    'emOpcUaNodeInfoEouni',
    'emOpcUaNodeSubscriptionEouns',
    'emOpcUaPublishRecordEoupr',
    'emOpcComputedEoc',
    'emOpcComputedTypeEoct',
    'emOpcWatchEow',
    'emOpcWatchConditionEowc',
    'emOpcComputedActionEoca',
    'emOpcComputedEventEoce'
]

const entities = {
    emOpcUaNodeInfoEouni,
    emOpcUaNodeSubscriptionEouns,
    emOpcUaPublishRecordEoupr,
    emOpcComputedEoc,
    emOpcComputedTypeEoct,
    emOpcWatchEow,
    emOpcWatchConditionEowc,
    emOpcComputedActionEoca,
    emOpcComputedEventEoce
}

export {genericEntities}

export default entities